"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectService = void 0;
const configuration_1 = require("@common/configuration");
const client_credential_service_1 = require("./base/client-credential.service");
class ConnectService extends client_credential_service_1.ClientCredentialService {
    constructor() {
        super(configuration_1.BackendConfiguration.connectServiceConfig());
    }
    async getLoginsByContactsIds(contacts) {
        var _a, _b;
        try {
            const axios = await this.axiosInstance();
            return (_b = (_a = (await axios.get(`${this.apiUrl}/v1/logins`, { params: { "filter[contact_id]": contacts } }))) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data;
        }
        catch (e) {
            this.logger.error("getLoginsByContactsIds error", e);
            throw e;
        }
    }
    async getConnectLoginsByEmail(email) {
        var _a, _b, _c;
        try {
            const axios = await this.axiosInstance();
            return (_c = (_b = (_a = (await axios.get(`${this.apiUrl}/v1/logins`, { params: { "filter[email]": email } }))) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c[0];
        }
        catch (e) {
            this.logger.error("getConnectLoginsByEmail error", e);
            throw e;
        }
    }
}
exports.ConnectService = ConnectService;
//# sourceMappingURL=connect.service.js.map